import React from 'react'
import CircleImage from "../Image/CircleImage";
import { Translate } from "react-redux-i18n";

export default function ProductInfo({ circle }) {
    return (
        <div className="custom-card">
            <div className="product-info">
                <div className="image rounded-product-image size-64">
                    <CircleImage size="small" src={circle.products[0].image_url} alt={circle.products[0].name} />
                </div>
                <div className="product-meta">
                    <h1 className="bp3-heading">{circle.products[0].name}</h1>
                    <div className="product-location-inline">
                        <strong>
                            <Translate value="circle_admin.location" />:{" "}
                        </strong>
                        {circle.address ? circle.address : circle.country}
                    </div>
                </div>
            </div>
        </div>
    )
}
